module.exports = __webpack_public_path__ + "static/media/shareLink.19f4a66d.svg";